import { render, staticRenderFns } from "./workListDetail.vue?vue&type=template&id=2b919f78&scoped=true&"
import script from "./workListDetail.vue?vue&type=script&lang=js&"
export * from "./workListDetail.vue?vue&type=script&lang=js&"
import style0 from "./workListDetail.vue?vue&type=style&index=0&id=2b919f78&scoped=true&lang=css&"
import style1 from "./workListDetail.vue?vue&type=style&index=1&id=2b919f78&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b919f78",
  null
  
)

export default component.exports